// extracted by mini-css-extract-plugin
export default {"section":"style_section__ELgOl","gallery":"style_gallery__G4mLV","image":"style_image__pjiq7","photo":"style_photo__+eFyY","btn":"style_btn__j11Mm"};